import { defineComponent as w, useId as k, computed as p, useTemplateRef as O, createElementBlock as o, createCommentVNode as C, openBlock as i, createVNode as r, unref as t, withCtx as m, createElementVNode as L, Fragment as y, normalizeClass as E, renderList as N, createBlock as P, createTextVNode as B, toDisplayString as h } from "vue";
import { TabGroup as F, TabList as V, TabPanels as A, TabPanel as D } from "@headlessui/vue";
import { ScalarMarkdown as M, ScalarCodeBlock as z } from "@scalar/components";
import { emitCustomEvent as G } from "@scalar/workspace-store/events";
import { getFeaturedClients as K, isFeaturedClient as R } from "../helpers/featured-clients.js";
import { DEFAULT_CLIENT as U } from "../../scalar-request-example-block/helpers/find-client.js";
import _ from "./ClientDropdown.vue.js";
const j = {
  key: 0,
  ref: "wrapper-ref"
}, q = ["id"], H = {
  key: 1,
  class: "selected-client card-footer border-t-0 p-0",
  role: "tabpanel",
  tabindex: "1"
}, J = ["id"], te = /* @__PURE__ */ w({
  __name: "ClientSelector",
  props: {
    xScalarSdkInstallation: {},
    clientOptions: {},
    xSelectedClient: { default: () => U }
  },
  setup(l, { expose: g }) {
    const v = k(), b = k(), x = p(
      () => l.clientOptions.flatMap(
        (e) => e.options.find((n) => n.id === l.xSelectedClient) ?? []
      )[0]
    ), c = p(() => K(l.clientOptions)), I = p(
      () => c.value.findIndex(
        (e) => l.xSelectedClient === e.id
      )
    ), S = O("wrapper-ref"), T = (e) => {
      const n = c.value[e];
      !n || !S.value || G(S.value, "scalar-update-selected-client", n.id);
    }, a = p(() => {
      var n;
      if (!Array.isArray(l.xScalarSdkInstallation) || !((n = l.xScalarSdkInstallation) != null && n.length))
        return;
      const e = l.xScalarSdkInstallation.find((u) => {
        var s, d;
        const f = (d = (s = l.xSelectedClient) == null ? void 0 : s.split("/")[0]) == null ? void 0 : d.toLowerCase();
        return u.lang.toLowerCase() === f;
      });
      if (e)
        return e;
    });
    return g({
      selectedClientOption: x
    }), (e, n) => e.clientOptions.length ? (i(), o("div", j, [
      r(t(F), {
        manual: "",
        selectedIndex: I.value,
        onChange: T
      }, {
        default: m(() => [
          L("div", {
            id: t(v),
            class: "client-libraries-heading"
          }, " Client Libraries ", 8, q),
          r(t(V), {
            "aria-labelledby": t(v),
            class: "client-libraries-list"
          }, {
            default: m(() => [
              r(_, {
                clientOptions: e.clientOptions,
                featuredClients: c.value,
                morePanel: t(b),
                xSelectedClient: e.xSelectedClient
              }, null, 8, ["clientOptions", "featuredClients", "morePanel", "xSelectedClient"])
            ]),
            _: 1
          }, 8, ["aria-labelledby"]),
          r(t(A), null, {
            default: m(() => {
              var u, f, s;
              return [
                (u = a.value) != null && u.source || (f = a.value) != null && f.description ? (i(), o(y, { key: 0 }, [
                  a.value.description ? (i(), o("div", {
                    key: 0,
                    class: E(["selected-client card-footer -outline-offset-2", a.value.source && "rounded-b-none"]),
                    role: "tabpanel",
                    tabindex: "0"
                  }, [
                    r(t(M), {
                      value: a.value.description
                    }, null, 8, ["value"])
                  ], 2)) : C("", !0),
                  a.value.source ? (i(), o("div", H, [
                    r(t(z), {
                      class: "rounded-t-none rounded-b-lg px-3 py-2 -outline-offset-1 has-focus:outline",
                      content: a.value.source,
                      copy: !0,
                      lang: "shell"
                    }, null, 8, ["content"])
                  ])) : C("", !0)
                ], 64)) : t(R)(e.xSelectedClient) ? (i(!0), o(y, { key: 1 }, N(c.value, (d) => (i(), P(t(D), {
                  key: d.id,
                  class: "selected-client card-footer -outline-offset-2"
                }, {
                  default: m(() => [
                    B(h(d.title), 1)
                  ]),
                  _: 2
                }, 1024))), 128)) : (i(), o("div", {
                  key: 2,
                  id: t(b),
                  class: "selected-client card-footer -outline-offset-2",
                  role: "tabpanel",
                  tabindex: "0"
                }, h((s = x.value) == null ? void 0 : s.title), 9, J))
              ];
            }),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["selectedIndex"])
    ], 512)) : C("", !0);
  }
});
export {
  te as default
};
